module.exports = __webpack_public_path__ + "img/lite-room-2.89be70e5.jpg";